const COPY_SELECTOR = '.user-profile-panel__email[data-copy-email]';
const FEEDBACK_DURATION_MS = 1600;

function legacyCopyText(value) {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    textarea.remove();
    return copied;
}

async function copyText(value) {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(value);
            return true;
        } catch (error) {
            return legacyCopyText(value);
        }
    }

    return legacyCopyText(value);
}

export function profileEmailCopy() {
    document.addEventListener('click', async (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }

        const button = event.target.closest(COPY_SELECTOR);
        if (!button) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        const email = button.dataset.copyEmail?.trim();
        if (!email) {
            return;
        }

        try {
            const copied = await copyText(email);
            if (!copied) {
                return;
            }

            const status = button.parentElement?.querySelector('.user-profile-panel__email-status');
            button.classList.add('is-copied');
            if (status) {
                status.textContent = button.dataset.copySuccess || 'Email copied to clipboard';
            }

            window.setTimeout(() => {
                button.classList.remove('is-copied');
                if (status) {
                    status.textContent = '';
                }
            }, FEEDBACK_DURATION_MS);
        } catch (error) {
            // Leave the menu unchanged if browser clipboard access is unavailable.
        }
    }, true);
}
